module.exports = __webpack_public_path__ + "static/media/icon-home-white.d1a45d0e.svg";